import React from "react";
import AdminLookupsListingComponent from "../../Components/adminLookupsListingComponent";

const LookUpListingPage = () => {
  return (
    <div className="main-wrapper">
      <div className="content-wrapper">
        <AdminLookupsListingComponent />
      </div>
    </div>
  );
};

export default LookUpListingPage;
